import * as firebase from "firebase/app";
import "firebase/firebase-firestore";
import "firebase/firebase-storage";
import "firebase/auth";
import { notificación, imagen, manejarCambiosFirebase } from '@/../../cliente_comun/utilidades'

var _firebase = null;
var _firestore = null;
var _storage = null;
export var _firestoreCuenta = null;
var _storageCuenta = null;

const inicializar = function() {
	_firebase = firebase.initializeApp({
		apiKey: "AIzaSyDOQW-MMic8TLqUTWyjPQoCyeA1u4wjpnw",
		authDomain: "comercios-3f6b4.firebaseapp.com",
		databaseURL: "https://comercios-3f6b4.firebaseio.com",
		projectId: "comercios-3f6b4",
		storageBucket: "comercios-3f6b4.appspot.com",
		messagingSenderId: "83073411529",
		appId: "1:83073411529:web:730662ef760e67d9486018"
	})

	_firestore = _firebase.firestore();
	_storage = _firebase.storage();

	autenticación.inicializar()
}

export const petición = {
	api: 'https://us-central1-comercios-3f6b4.cloudfunctions.net/api',
	post: function(recurso, datos) {
		return this.enviar('POST', recurso, datos)
	},
	put: function(recurso, datos) {
		return this.enviar('PUT', recurso, datos)
	},
	get: function(recurso, datos) {
		return this.enviar('GET', recurso, datos)
	},
	delete: function(recurso) {
		return this.enviar('DELETE', recurso)
	},
	enviar: async function(metodo, recurso, datos) {
		let eje = async () => {
			let res = await fetch(`${this.api}${recurso}`, {
				method: metodo,
				body: datos ? JSON.stringify(datos) : null,
				headers: {
					'Authorization': `Bearer ${autenticación.usuario.token}`,
					'X-Cuenta': autenticación.cuenta.identificador,
					'Content-Type': 'application/json',
				}
			})

			if (!res.ok) {
				throw { msj: atob(res.headers.get('X-Error') || '[8888] Ocurrió un error.') }
			}

			return { identificador: res.headers.get('X-Identificador') || '' }
		}

		try {
			return await eje()
		} catch (err) {
			let msj = err.msj || '[7777] Ocurrió un error inesperado. Refresque la página.'
			notificación.error(msj)
			return Promise.reject({ notificado: true })
		}
	}
}

const autenticación = {
	cargaInicial: false,
	//autenticado: false,
	autenticando: false,
	cargandoUsuario: false,
	cambiandoContraseña: false,
	usuario: {
		identificador: '',
		nombres: '',
		apellidos: '',
		correo: '',
		token: ''
	},
	cuenta: {
		identificador: '',
		empresa: {
			nombreComercial: '',
			nombreLegal: '',
			país: ''
		}
	},
	acceder: function(correo, contraseña){
		correo = (correo || '').trim()
		contraseña = (contraseña || '').trim()
		this.autenticando = true
		_firebase.auth().signInWithEmailAndPassword(correo, contraseña).then( () => {
			//
		}).catch( error => {
			let err = '[2345] Ocurrió un error'
			if (error.code === 'auth/invalid-email') {
				err = 'Correo electrónico no válido'
			} else if (error.code === 'auth/wrong-password' || error.code === 'auth/user-not-found') {
				err = 'Correo o contraseña errados'
			}
			notificación.error(err)
			window.console.error(error.code, error.message)
			this.autenticando = false
		});
	},
	cambiarContraseña: function(contraseña1, contraseña2) {
		if (!contraseña1) {
			notificación.error('Falta la contraseña.')
			return Promise.reject()
		} else if (!contraseña2) {
			notificación.error('Debe confirmar la contraseña.')
			return Promise.reject()
		} else if (typeof contraseña1 !== 'string' || typeof contraseña2 !== 'string') {
			notificación.error('Contraseña errada.')
			return Promise.reject()
		}

		contraseña1 = contraseña1.trim()
		contraseña2 = contraseña2.trim()

		if (contraseña1 !== contraseña2) {
			notificación.error('Las contraseñas no coinciden.')
			return Promise.reject()
		} else if (contraseña1.length < 8) {
			notificación.error('La contraseña debe tener al menos ocho caracteres.')
			return Promise.reject()
		}

		this.cambiandoContraseña = true
		return _firebase.auth().currentUser.updatePassword(contraseña1).then(() => {
			this.cambiandoContraseña = false
			notificación.correcto('Contraseña cambiada.')
			return Promise.resolve()
		}).catch(err => {
			this.cambiandoContraseña = false
			let msj = '[7538] Ocurrió un error.'
			if (err.code === 'auth/requires-recent-login') {
				msj = 'Para cambiar la contraseña se requiere que haya iniciado sesión recientemente. Cierre sesión y volver a inciar.'
			}
			console.error(msj)
			console.error(err)
			notificación.error(msj)
			return Promise.reject()
		})
	},
	cerrar: function() {
		_firebase.auth().signOut()
	},
	inicializar: function() {
		_firebase.auth().onAuthStateChanged( user => {
			this.autenticando = false
			if (user) {
				this.cargandoUsuario = true
				user.getIdToken().then(tkn => {
					_firestore.collection('usuarios').doc(user.uid).get().then( doc => {
						let datos = doc.data()
						if (doc.exists && datos.cuentas && datos.cuentas.length && datos.cuentas[0]) {
							this.usuario = Object.assign({identificador: user.uid, correo: user.email, token: tkn}, datos)
							this.cuenta.identificador = datos.cuentas[0] // pendiente esto--------------

							// Firestore:
							_firestoreCuenta = _firestore.collection('cuentas').doc(this.cuenta.identificador)
	
							// Storage:
							_storageCuenta = _storage.ref().child('cuentas').child(this.cuenta.identificador)

							_firestoreCuenta.get().then( doc => {
								this.cuenta.empresa = doc.data().empresa
								impuestosDePaís.inicializar()
							})
	
						} else {
							console.error('[6423] Ocurrió un error: No se pudo obtener el usuario.')
							this.error('[6423] Ocurrió un error')
						}
						this.cargandoUsuario = false
						this.cargaInicial = true
					}).catch( err => {
						console.error('[6424]', err)
						this.error('[6424] Ocurrió un error')
						this.cargandoUsuario = false
						this.cargaInicial = true
					})
				}).catch(err => {
					console.error('[7539] Ocurrió un error.', err)
				})
			} else {
				productos.desconectar()
				personas.desconectar()
				facturasDeVenta.desconectar()
				facturasDeCompra.desconectar()
				definicionesDeImpuestos.desconectar()
				usuarios.desconectar()
				movimientoDeInventarioDeProducto.desconectar()
				impuestosDePaís.desconectar()
				identificacionesDePaís.desconectar()
				this.usuario = {}
				this.cuenta.identificador = ''
				this.cargaInicial = true
				_firestoreCuenta = null
				_storageCuenta = null
			}
		});
	}
}


const usuarios = {
	listando: false,
	listado: [],
	_desconectar: null,
	inicializar: function() {
		if (this._desconectar) {
			return
		}

		this.listado = []
		this.listando = true
		this._desconectar = _firestore.collection('usuarios').where('cuentas', 'array-contains', autenticación.cuenta.identificador).onSnapshot( snapshot => {
			manejarCambiosFirebase(this.listado, snapshot)
			this.listando = false
		})
	},
	guardar: function(d, identificador) {
		//
	},
	desconectar: function() {
		if (this._desconectar) {
			this._desconectar()
			this._desconectar = null
		}
		this.listado = []
	}
}


const productos = {
	listando: false,
	listado: [],
	guardando: false,
	guardandoInventario: false,
	_desconectar: null,
	inicializar: function() {
		if (this._desconectar) {
			return
		}

		this.listado = []
		this.listando = true
		this._desconectar = _firestoreCuenta.collection('productos').onSnapshot( snapshot => {
			manejarCambiosFirebase(this.listado, snapshot, { agregarAlInicio: true })
			this.listando = false
		})
	},
	guardar: function(d, identificador) {
		let referenciasImágenes;

		this.guardando = true
		return this.preparar(d).then(datos => {

			let manejarImagen = async () => {
				if (d._eliminarImagenPrincipal || d._imagenPrincipal) {
					await this.eliminarImagenPrincipal(datos)
					if (d._imagenPrincipal) {
						let resAgr = await this.agregarImagenPrincipal(datos, d._imagenPrincipal)
						referenciasImágenes = resAgr.referencias
					}
				}

				return datos
			}

			return manejarImagen()
		}).then(datos => {
			let P = null
			if (identificador) {
				P = petición.put(`/administracion/v1/productos/${identificador}`, datos)
			} else {
				P = petición.post('/administracion/v1/productos', datos)
			}

			return P
		}).then(res => {
			this.guardando = false
			notificación.correcto('Producto guardado.')
			return res
		}).catch(err => {
			this.guardando = false
			console.error('[4738]', err)
			if (!err.notificado) {
				notificación.error(err.error || '[4738] Ocurrió un error')
			}

			if (referenciasImágenes) {
				for (let ref of referenciasImágenes) {
					ref.delete()
				}
			}

			return Promise.reject()
		})

	},
	guardarMovimientoDeInventario: function(identificador, d) {
		if (!identificador || !d) {
			notificación.error('[7532] Ocurrió un error')
			return Promise.reject()
		} else if (!d.motivo || !d.motivo.toString().trim() || d.motivo.toString().trim().length <= 2) {
			notificación.error('Escriba el motivo por el que está haciendo cambios a la existencia del producto.')
			return Promise.reject()
		}

		let datos = JSON.parse(JSON.stringify(d))
		datos.cantidad = Number(d.cantidad)

		if (datos.cantidad <= 0 || isNaN(datos.cantidad) || !isFinite(datos.cantidad) || Math.floor(datos.cantidad) !== datos.cantidad) {
			notificación.error('Cantidad errada o faltante.')
			return Promise.reject()
		}

		this.guardandoInventario = true
		return petición.post(`/administracion/v1/productos/${identificador}/movimiento`, datos).then(() => {
			this.guardandoInventario = false
			notificación.correcto('¡Hecho!')
		}).catch( err => {
			this.guardandoInventario = false
			return Promise.reject()
		})
	},
	eliminarImagenPrincipal: function(datos) {
		let promesas = []

		if (datos.imágenes && datos.imágenes.principal) {
			if (datos.imágenes.principal.grande.indexOf('firebasestorage.googleapis.com') >= 0) {
				promesas.push(_storage.refFromURL(datos.imágenes.principal.grande).delete())
			}
			if (datos.imágenes.principal.pequeña.indexOf('firebasestorage.googleapis.com') >= 0) {
				promesas.push(_storage.refFromURL(datos.imágenes.principal.pequeña).delete())
			}

			datos.imágenes.principal.pequeña = ''
			datos.imágenes.principal.grande = ''
			datos.imágenes.principal.peso = 0
			// Pendiente: Actualizar en BD
		}

		let P = Promise.resolve()

		if (promesas.length > 0) {
			P = Promise.allSettled(promesas).then( results => {
				for (const i in results) {
					if (results[i].status === 'fulfilled') {
						// Bien
					} else if (results[i].status === 'rejected' && results[i].reason.code === 'storage/object-not-found') {
						// No encontrada, nada que eliminar. Pasa porque no se actualiza en BD (ver comentario unas líneas más arriba)
						console.warn('[398456475]')
					} else {
						return Promise.reject(results[i].reason)
					}
				}

				return Promise.resolve()
			}).catch( err => {
				console.warn('[7321] No se pudo borrar la referencia de imagen principal.', err)
				notificación.error('[7321] Ocurrió un error al borrar o actualizar la imagen.')
				return Promise.reject({ notificado: true })
			})
		}

		return P
	},
	agregarImagenPrincipal: function(datos, img) {
		let docRef = _firestoreCuenta.collection('productos').doc()
		let refImg = _storageCuenta.child('productos').child('imágenes')
		let opciones = {
			nombreGrande: `${docRef.id}-g - ${img.name}`,
			nombrePequeña: `${docRef.id}-p - ${img.name}`
		}

		return imágenes.cargar(refImg, img, opciones).then(res => {
			datos.imágenes.principal.pequeña = res.pequeña.ubicación
			datos.imágenes.principal.grande = res.grande.ubicación
			datos.imágenes.principal.peso = res.peso
			return Promise.resolve({ referencias: [res.pequeña.referencia, res.grande.referencia] })
		}).catch( err => {
			let msj = '[7322] Ocurrió un error al guardar la imagen.'
			if (err && err.error) {
				msj = `${err.error} - ${msj}`
			}
			console.warn(msj, err)
			notificación.error(msj)
			return Promise.reject({ notificado: true })
		})
	},
	preparar: function(d) {
		let precio = Number(d._precio)
		let enInventario = Number(d.enInventario)

		if (!d.descripción.trim()) {
			return Promise.reject({ error: 'Falta la descripción del producto' })
		} else if (isNaN(enInventario) || !isFinite(enInventario) || Math.floor(enInventario) !== enInventario || enInventario < 0) {
			return Promise.reject({ error: 'Cantidad en inventario faltante o errada' })
		} else if (!d.definiciónDeImpuestos) {
			return Promise.reject({ error: 'Falta la definición de impuestos' })
		} else if (isNaN(precio) || !isFinite(precio) || precio <= 0) {
			return Promise.reject({ error: 'Precio faltante o errado' })
		}

		let datos = {
			habilitado: d.habilitado,
			código: (d.código || '').trim(),
			descripción: d.descripción.trim(),
			enInventario: enInventario,
			definiciónDeImpuestos: d.definiciónDeImpuestos,
			precioDeCoste: d.precioDeCoste ? d.precioDeCoste : { moneda: 'COP', monto: '' },
			precios: [{moneda: 'COP', monto: precio.toString()}],
			imágenes: {
				principal: {
					pequeña: d.imágenes && d.imágenes.principal.pequeña ? d.imágenes.principal.pequeña : '',
					grande: d.imágenes && d.imágenes.principal.grande ? d.imágenes.principal.grande : '',
					peso: 0,
				},
				otras: [],
			}
		}

		return Promise.resolve(datos)
	},
	desconectar: function() {
		if (this._desconectar) {
			this._desconectar()
			this._desconectar = null
		}
		this.listado = []
	}
}



const personas = {
	listado: [],
	listando: false,
	guardando: false,
	_desconectar: null,
	inicializar: function() {
		if (this._desconectar) {
			return
		}

		this.listado = []
		this.listando = true
		this._desconectar = _firestoreCuenta.collection('personas').orderBy('creación.fecha').onSnapshot( snapshot => {
			manejarCambiosFirebase(this.listado, snapshot)
			this.listando = false
		})
	},
	guardar: function(datos, identificador) {
		if (!datos) {
			notificación.error('[7583] Error leyendo datos.')
			return Promise.reject()
		} else if (datos.tipo !== 'natural' && datos.tipo !== 'jurídica') {
			notificación.error('Tipo de persona faltante o errada.')
			return Promise.reject()
		} else if (datos.tipo === 'natural' && (!datos.natural || !datos.natural.nombres)) {
			notificación.error('Falta el nombre de la persona.')
			return Promise.reject()
		} else if (datos.tipo === 'jurídica' && (!datos.jurídica || !datos.jurídica.nombreLegal)) {
			notificación.error('Falta el nombre legal de la empresa.')
			return Promise.reject()
		}

		let P = null
		if (identificador) {
			P = petición.put(`/administracion/v1/personas/${identificador}`, datos)
		} else {
			P = petición.post('/administracion/v1/personas', datos)
		}

		this.guardando = true
		return P.then(() => {
			notificación.correcto('Persona guardada.')
			this.guardando = false
		}).catch(() => {
			this.guardando = false
			return Promise.reject()
		})
	},
	desconectar: function() {
		if (this._desconectar) {
			this._desconectar()
			this._desconectar = null
		}
		this.listado = []
	}
}

const definicionesDeImpuestos = {
	listando: false,
	listado: [],
	guardando: false,
	_desconectar: null,
	inicializado: false,
	inicializar: function() {
		if (this.inicializado) {
			return Promise.resolve()
		}

		this.listado = []
		this.listando = true

		return new Promise((resolve, reject) => {
			this._desconectar = _firestoreCuenta.collection('definicionesDeImpuestos').onSnapshot( snapshot => {
				manejarCambiosFirebase(this.listado, snapshot)
				this.listando = false
				if (!this.inicializado) {
					this.inicializado = true
					resolve()
				}
			}, error => {
				console.error('[4839]', error)
				reject()
			})
		})
	},
	guardar: function(datos, identificador) {
		if (!datos) {
			notificación.error('[3325] Error leyendo datos.')
			return Promise.reject()
		} else if (!datos.descripción) {
			notificación.error('Falta la descripción.')
			return Promise.reject()
		}

		let impuestos = []
		for (let impuesto of datos.impuestos) {
			if (impuesto.seleccionado) {

				let alternativas = []
				for (let definición of impuesto.alternativas) {
					if (definición.seleccionado) {
						alternativas.push({ porcentaje: definición.porcentaje})
					}
				}

				if (alternativas.length === 0) {
					notificación.error(`No hay alternativas para ${impuesto.descripción.abreviada}.`)
					return Promise.reject()
				}

				impuestos.push({
					identificador: impuesto.identificador,
					requerido: impuesto.requerido,
					descripción: JSON.parse(JSON.stringify(impuesto.descripción)),
					alternativas: alternativas
				})

			}
		}

		let ahora = new Date()
		datos = {
			descripción: datos.descripción,
			impuestos: impuestos,
			creación: {
				fecha: firebase.firestore.FieldValue.serverTimestamp(),
				usuario: {
					identificador: autenticación.usuario.identificador,
					nombres: autenticación.usuario.nombres,
					apellidos: autenticación.usuario.apellidos,
				}
			}
		}

		let docRef;
		if (identificador) {
			docRef = _firestoreCuenta.collection('definicionesDeImpuestos').doc(identificador)
		} else {
			docRef = _firestoreCuenta.collection('definicionesDeImpuestos').doc()
		}

		this.guardando = true
		return docRef.set(datos).then(dRef => {
			this.guardando = false
			notificación.correcto('¡Guardado!')
		}).catch( err => {
			this.guardando = false
			console.error('[7539]', err)
			notificación.error('[7539] Ocurrió un error. Intente nuevamente.')
		})
	},
	desconectar: function() {
		if (this._desconectar) {
			this._desconectar()
			this._desconectar = null
		}
		this.listado = []
		this.inicializado = false
	}
}

const facturasDeVenta = {
	listando: false,
	listado: [],
	listadoDosMeses: [],
	listandoDosMeses: false,
	guardando: false,
	anulando: false,
	_desconectar: null,
	_desconectarDesde:null, // Al hacer esto no se reinicializan los demás datos........ pendiente manejar eso ----
	_almacenandoBorrador: null,
	inicializar: function() {
		if (this._desconectar) {
			return
		}

		this.listado = []
		this.listando = true
		this._desconectar = _firestoreCuenta.collection('facturasDeVenta').orderBy('creación.fecha', 'asc').onSnapshot( snapshot => {
			manejarCambiosFirebase(this.listado, snapshot, { agregarAlInicio: true })
			this.listando = false
		})
	},
	listar: function(desde, hasta) {
		let refFacturas = _firestoreCuenta.collection('facturasDeVenta')
		return refFacturas.where('creación.fecha', '>=', desde).where('creación.fecha', '<', hasta).get().then(docs => {
			if (docs.empty) {
				return Promise.resolve([])
			}

			let listado = []
			docs.forEach(doc => {
				listado.push(Object.assign({identificador: doc.id}, doc.data()))
			})

			return Promise.resolve(listado)
		}).catch(err => {
			console.error('[7938]', err)
			notificación.error('[7938] Ocurrió un error.')
			return Promise.reject()
		})
	},
	guardar: function(datos) {
		if (!datos) {
			notificación.error('[2325] Error leyendo datos.')
			return Promise.reject()
		} else if (!datos.productos || datos.productos.length === 0) {
			notificación.error('No hay productos agregados.')
			return Promise.reject()
		} else if (!datos.subtotal || !datos.total || datos.subtotal <= 0 || datos.total <= 0) {
			notificación.error('No hay precios establecidos.')
			return Promise.reject()
		} else if (!datos.moneda) {
			notificación.error('No se estableció una moneda.')
			return Promise.reject()
		}

		for (let p of datos.productos) {
			if (p.cantidad > p.enInventario) {
				notificación.error(`Sólo hay ${p.enInventario} unidades disponibles de «${p.descripción}».`)
				return Promise.reject()
			}
			for (let i of p.impuestos) {
				if (i.requerido && !i.porcentaje) {
					notificación.error(`Falta el impuesto de «${p.descripción}».`)
					return Promise.reject()
				}
			}

			let ctdd = Number(p.cantidad)
			if (p.cantidad === '0' || p.cantidad === '') {
				notificación.error(`Falta la cantidad de «${p.descripción}».`)
				return Promise.reject()
			} else if (ctdd <= 0 || !isFinite(ctdd) || isNaN(ctdd)) {
				notificación.error(`Cantidad errada de «${p.descripción}».`)
				return Promise.reject()
			}
		}

		datos = JSON.parse(JSON.stringify(datos)) // Evitar problemas en caso de que falle tras ejecutarse los delete...

		let ahora = new Date()
		Object.assign(datos, {
			anulada: false,
			creación: {
				fecha: firebase.firestore.FieldValue.serverTimestamp(),
				usuario: {
					identificador: autenticación.usuario.identificador,
					nombres: autenticación.usuario.nombres,
					apellidos: autenticación.usuario.apellidos,
				}
			}
		})

		datos.subtotal = datos.subtotal.toString()
		datos.montoDeImpuestos = datos.montoDeImpuestos.toString()
		datos.total = datos.total.toString()

		if (!datos.fechaDeEmisión) {
			datos.fechaDeEmisión = ahora.toISOString().substr(0, 10)
		}

		for (let i in datos.productos) {
			delete datos.productos[i].precios
			delete datos.productos[i].imágenes
			delete datos.productos[i].creación
			for (let j in datos.productos[i].impuestos) {
				delete datos.productos[i].impuestos[j].alternativas
			}
			datos.productos[i].cantidad = Number(datos.productos[i].cantidad)
		}

		this.guardando = true
		return _firestoreCuenta.collection('facturasDeVenta').add(datos).then( docRef => {
			let lote = _firestore.batch();
			for (let p of datos.productos) {
				let enInventario = p.enInventario - p.cantidad
				delete p.enInventario
				let dvp = {
					creación: {
						fecha: firebase.firestore.FieldValue.serverTimestamp(),
						usuario: {
							identificador: autenticación.usuario.identificador,
							nombres: autenticación.usuario.nombres,
							apellidos: autenticación.usuario.apellidos,
						}
					},
					facturaDeVenta: {identificador: docRef.id},
					moneda: datos.moneda,
					impuestos: p.impuestos,
					descripción: p.descripción,
					precioUnitario: p.precioUnitario,
					cantidad: p.cantidad,
					subtotal: p.precioSubtotal,
					total: p.precioTotal,
					montoDeImpuestos: p.montoDeImpuestos
				}

				let dmip = {
					creación: {
						fecha: firebase.firestore.FieldValue.serverTimestamp(),
						usuario: {
							identificador: autenticación.usuario.identificador,
							nombres: autenticación.usuario.nombres,
							apellidos: autenticación.usuario.apellidos,
						}
					},
					cantidad: p.cantidad,
					motivo: '',
					origen: 'venta',
					tipo: 'salida',
					facturaDeVenta: {
						identificador: docRef.id,
					},
				}

				let refP = _firestoreCuenta.collection('productos').doc(p.identificador)
				let refMIP = refP.collection('movimientosDeInventarioDeProducto').doc()
				let refVP = refP.collection('ventasDeProducto').doc()
				lote.update(refP, {enInventario})
				lote.set(refVP, dvp)
				lote.set(refMIP, dmip)
			}

			return lote.commit().then( () => {
				this.guardando = false
				notificación.correcto('¡Guardado!')
			}).catch( err => {
				this.guardando = false
				console.error('[2371]', err)
				_firestoreCuenta.collection('facturasDeVenta').doc(docRef.id).delete()
				window.alert('[2371] Ocurrió un error. No se pudo guardar.')
			})
		}).catch( err => {
			this.guardando = false
			console.error('[4378]', err)
			notificación.error('[4378] Ocurrió un error. Intente nuevamente.')
		})
	},
	anular: function(identificador) {
		if (!identificador) {
			notificación.error('[7581] Ocurrió un error.')
			return Promise.reject()
		}

		console.log(`Anulando factura ${identificador}...`)

		this.anulando = true
		let lote = _firestore.batch()
		let refFctra = _firestoreCuenta.collection('facturasDeVenta').doc(identificador)

		return refFctra.get().then( docRef => {
			if (!docRef.exists) {
				return Promise.reject({error: '[7582] Ocurrió un error.'})
			}

			let datos = docRef.data()
			if (datos.anulada) {
				return Promise.reject({error: 'Esta factura ya está anulada.'})
			}

			let promesasVentasDeProductos = []
			for (let p of datos.productos) {
				let dmip = {
					creación: {
						fecha: firebase.firestore.FieldValue.serverTimestamp(),
						usuario: {
							identificador: autenticación.usuario.identificador,
							nombres: autenticación.usuario.nombres,
							apellidos: autenticación.usuario.apellidos,
						}
					},
					cantidad: p.cantidad,
					motivo: '',
					origen: 'anulación_de_venta',
					tipo: 'entrada',
					facturaDeVenta: {
						identificador: identificador,
					},
				}

				let refPdcto = _firestoreCuenta.collection('productos').doc(p.identificador)
				let refMIP = refPdcto.collection('movimientosDeInventarioDeProducto').doc()
				lote.update(refFctra, {anulada: true})
				lote.update(refPdcto, {enInventario: firebase.firestore.FieldValue.increment(p.cantidad)})
				lote.set(refMIP, dmip)
				promesasVentasDeProductos.push(refPdcto.collection('ventasDeProducto').where('factura.identificador', '==', identificador).get())
			}

			return Promise.all(promesasVentasDeProductos)
		}).then(prmssVntsPdcts => {
			for (let q of prmssVntsPdcts) {
				q.forEach(docRef => {
					lote.delete(docRef.ref)
				})
			}

			return lote.commit().catch( err => {
				console.error('[7583]', err)
				return Promise.reject({error: '[7583] Ocurrió un error.'})
			})
		}).then(() => {
			this.anulando = false
			notificación.correcto('¡Factura anulada!')
		}).catch( err => {
			this.anulando = false
			console.log('[7584]', err)
			notificación.error(err.error || '[7584] Ocurrió un error.')
			return Promise.reject()
		})
	},
	almacenarBorrador: function(identificadorLocal, datos) {
		clearTimeout(this._almacenandoBorrador)
		this._almacenandoBorrador = setTimeout( () => {
			let l = `tpv.${autenticación.usuario.identificador}.facturas`
			let d = Object.assign({ identificadorLocal: identificadorLocal }, datos)

			let ind = -1
			let ftrs = this.recuperarBorradores()
			for (let i in ftrs) {
				if (ftrs[i].identificadorLocal === identificadorLocal) {
					ftrs[i] = d
					ind = i
					break
				}
			}

			if (ind >= 0 && datos.productos.length === 0) {
				ftrs.splice(ind, 1)
			}

			if (ind < 0 && datos.productos.length > 0) {
				ftrs.push(d)
			}

			let v = btoa(encodeURIComponent(JSON.stringify(ftrs)))

			window.localStorage.setItem(l, v)
		}, 100)
	},
	recuperarBorradores: function() {
		let ftrs = window.localStorage.getItem(`tpv.${autenticación.usuario.identificador}.facturas`)
		if (!ftrs) {
			return []
		}

		ftrs = JSON.parse(decodeURIComponent(atob(ftrs)))

		return ftrs
	},
	desconectar: function() {
		if (this._desconectar) {
			this._desconectar()
			this._desconectar = null
		}
		if (this._desconectarDesde) {
			this._desconectarDesde()
			this._desconectarDesde = null
		}
		this.listado = []
		this.listadoDosMeses = []
	}
}

const facturasDeCompra = {
	listado: [],
	listando: false,
	guardando: false,
	anulando: false,
	_desconectar: null,
	inicializar: function() {
		if (this._desconectar) {
			return
		}

		this.listado = []
		this.listando = true
		this._desconectar = _firestoreCuenta.collection('facturasDeCompra').orderBy('creación.fecha', 'asc').onSnapshot( snapshot => {
			manejarCambiosFirebase(this.listado, snapshot, { agregarAlInicio: true })
			this.listando = false
		})
	},
	guardar: function(datos) {
		if (!datos) {
			notificación.error('[7593] Error leyendo datos.')
			return Promise.reject()
		} else if (!datos.productos || datos.productos.length === 0) {
			notificación.error('No hay productos agregados.')
			return Promise.reject()
		} else if (!datos.total || datos.total <= 0) {
			notificación.error('No hay precios establecidos.')
			return Promise.reject()
		}

		this.guardando = true
		return petición.post('/administracion/v1/facturas-de-compra', datos).then(() => {
			notificación.correcto('Factura de compra guardada.')
			this.guardando = false
		}).catch(() => {
			this.guardando = false
			return Promise.reject()
		})
	},
	anular: function(identificador) {
		if (!identificador) {
			notificación.error('No se recibió el identificador.')
			return Promise.reject()
		}

		this.anulando = true
		return petición.delete(`/administracion/v1/facturas-de-compra/${identificador}`).then(() => {
			notificación.correcto('Factura de compra anulada.')
			this.anulando = false
		}).catch(() => {
			this.anulando = false
			return Promise.reject()
		})
	},
	desconectar: function() {
		if (this._desconectar) {
			this._desconectar()
			this._desconectar = null
		}
		this.listado = []
	}
}

const movimientoDeInventarioDeProducto = {
	listando: false,
	listado: [],
	_desconectar: null,
	listar: function(identificadorDeProducto) {
		if (this._desconectar) {
			this._desconectar()
		}

		this.listado = []
		this.listando = true
		this._desconectar = _firestoreCuenta.collection('productos').doc(identificadorDeProducto).collection('movimientosDeInventarioDeProducto').orderBy('creación.fecha', 'desc').limit(50).onSnapshot( snapshot => {
			manejarCambiosFirebase(this.listado, snapshot)
			this.listando = false
		})
	},
	desconectar: function() {
		if (this._desconectar) {
			this._desconectar()
			this._desconectar = null
		}
		this.listado = []
	}
}

const impuestosDePaís = {
	listando: false,
	listado: [],
	_desconectar: null,
	inicializar: function() {
		if (this._desconectar) {
			return
		}

		this.listado = []
		this.listando = true
		this._desconectar = _firestore.collection('paises').doc(autenticación.cuenta.empresa.país).collection('impuestosDePais').onSnapshot( snapshot => {
			manejarCambiosFirebase(this.listado, snapshot)
			this.listando = false
		})
	},
	desconectar: function() {
		if (this._desconectar) {
			this._desconectar()
			this._desconectar = null
		}
		this.listado = []
	}
}

const identificacionesDePaís = {
	listando: false,
	listado: [],
	_desconectar: null,
	inicializar: function() {
		if (this._desconectar) {
			return
		}

		this.listado = []
		this.listando = true
		this._desconectar = _firestore.collection('paises').doc(autenticación.cuenta.empresa.país).collection('identificacionesDePais').onSnapshot( snapshot => {
			manejarCambiosFirebase(this.listado, snapshot)
			this.listando = false
		})
	},
	desconectar: function() {
		if (this._desconectar) {
			this._desconectar()
			this._desconectar = null
		}
		this.listado = []
	}
}

var archivos = {
	cargar: function(referenciaRaíz, arch, nombre, funciónDeCarga) {
		nombre = nombre || arch.name.replace(/[\[\]\#\*\?]/g, '_')
		let referencia = referenciaRaíz.child(nombre)
		let carga = referencia.put(arch)

		return new Promise((resolve, reject) => {
			carga.on('state_changed', snapshot => {
				if (funciónDeCarga) {
					funciónDeCarga(snapshot)
					//this.progreso = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
				}
			}, error => {
				let err = '[7893] Ocurrió un error'
				switch (error.code) {
					case 'storage/unauthenticated':
						err = 'Tu sesión caducó. Recarga la página e inicia sesión de nuevo.'
						break;
					case 'storage/canceled':
						err = 'Cancelaste la carga.'
						break;
				}
				reject({ error: err })
			}, () => {
				carga.snapshot.ref.getDownloadURL().then( downloadURL => {
					//resolve({ ubicación: downloadURL + '?alt=media', referencia: referencia })
					resolve({ ubicación: downloadURL, referencia: referencia })
				});
			});
		})
	}
}

var imágenes = {
	cargar: function(referenciaRaíz, img, opciones) {
		if (!opciones || !opciones.nombreGrande || !opciones.nombrePequeña) {
			return Promise.reject({ error: '[8492] Ocurrió un error' })
		}

		let P1 = imagen.redimensionarA1000(img)
		let P2 = imagen.redimensionarA200(img)

		return Promise.all([P1, P2]).then( rtas => {
			if (rtas.length !== 2 || rtas[0].tipo !== '1000px' || rtas[1].tipo !== '200px') {
				return Promise.reject({ error: '[8493] Ocurrió un error' })
			}

			return archivos.cargar(referenciaRaíz, rtas[0].imagen, opciones.nombreGrande).then(res1 => {
				return archivos.cargar(referenciaRaíz, rtas[1].imagen, opciones.nombrePequeña).then(res2 => {
					return Promise.resolve({ grande: res1, pequeña: res2, peso: rtas[0].imagen.size + rtas[1].imagen.size })
				}).catch(err => {
					res1.referencia.delete()
					return Promise.reject(err)
				})
			})
		}).then(rta => {
			if (!rta.grande || !rta.pequeña || !rta.peso) {
				return Promise.reject({ error: '[8494] Ocurrió un error' })
			}

			return Promise.resolve(rta)
		})
	}
}


export {
	inicializar,
	autenticación,
	usuarios,
	productos,
	personas,
	facturasDeVenta,
	facturasDeCompra,
	movimientoDeInventarioDeProducto,
	definicionesDeImpuestos,
	impuestosDePaís,
	identificacionesDePaís,
	imágenes
}
